module.exports = __webpack_public_path__ + "static/img/lw.860f9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/lw.png
// module id = OgF2
// module chunks = 26